import React from 'react';
import * as Render from '../platformui/Base/Render';
import SubjectIntroBlock from './subject-intro-block';

const Blocks = {
  SubjectIntroBlock,
};

export default (props) => (
  <Render.Block
    blocks={props.Content}
    propertyName="Content"
    currentPageProps={props}
  >
    <Render.BlockTypeRenderer Blocks={Blocks} />
  </Render.Block>
);
